import React, { useState } from 'react';
import { Collapse } from '@m4b-design/components';
import { IconDown, IconUp } from '@arco-design/iconbox-react-m4b-next';
import cx from 'classnames';
import styles from './index.scss';
import { LearningInfo } from '@/api/seller/serv/oec_seller_learning_center_api';
import { Tea } from '@features/libs/tea';
import { useContextUser } from '@features/hooks';
import Dompurify from 'dompurify';
const CollapseItem = Collapse.Item;

export enum PageDisplay {
  Home,
  Faq,
}

interface CollapseListProps {
  pageDisplay?: PageDisplay;
  dataList?: Array<LearningInfo>;
  pageName?: string;
}

const CollapseList: React.FC<CollapseListProps> = props => {
  const { dataList, pageDisplay, pageName } = props;
  const [curActiveKey, setCurActiveKey] = useState();
  const [user] = useContextUser();

  const onCollapseChange = key => {
    setCurActiveKey(() => {
      if (curActiveKey === key) {
        return null;
      } else {
        const idx = dataList?.findIndex(item => item.name === key);
        Tea('button_click', {
          page_name: pageName ?? 'seller_university_faq',
          is_login: !!user.user_id,
          module_name: 'faq',
          number: idx,
          content: key,
          click_for: 'unfold',
        });
        return key;
      }
    });
  };

  return (
    <>
      <Collapse
        className={cx(
          pageDisplay === PageDisplay.Faq
            ? styles.FaqBgColor
            : styles.homeBgColor,
        )}
        expandIcon={null}
        bordered={false}
        accordion={true}
        activeKey={curActiveKey}
        onChange={onCollapseChange}>
        {dataList?.map(item => {
          return (
            <CollapseItem
              name={item.name}
              key={item.learning_id}
              header={{ title: item.name }}
              extra={curActiveKey === item.name ? <IconUp /> : <IconDown />}
              className="text-p2-semibold"
              contentStyle={{
                fontWeight: 400,
                fontSize: 14,
                lineHeight: '20px',
              }}>
              <span
                className="whitespace-pre-line"
                dangerouslySetInnerHTML={{
                  __html: textSupportLink(
                    item?.content?.replace(/^(?:[\n\r]*)|(?:[\n\r]*)$/g, '') ??
                      '',
                  ),
                }}></span>
            </CollapseItem>
          );
        })}
      </Collapse>
    </>
  );
};

export const textSupportLink = (text: string) => {
  return Dompurify.sanitize(
    text.replace(
      /(?:http(s)?:\/\/)[\w.-]+(?:\.[\w.-]+)+[\w-._~:/?#[\]@!$&'*+,;=.]+/g,
      '<a href="$&" target="_blank" style="color: #3370dd">$&</a>',
    ),
    { ADD_ATTR: ['TARGET'], ALLOWED_TAGS: ['a'] },
  );
};

export default CollapseList;
